// extracted by mini-css-extract-plugin
export var optionGrid = "_32-7";
export var optionList = "_32-6";
export var questionsBlock = "_32-9";
export var spacer = "_32-5";
export var stepCenteredContent = "_32-3";
export var stepInner = "_32-0";
export var stepInnerFullWidth = "_32-1";
export var stepInnerLockScroll = "_32-2";
export var stepTransitionFrame = "_32-4";
export var welcomeBlock = "_32-8";